import {getUrl, searchPath} from '@github-ui/paths'
import {updateSearchBar} from '../hooks/use-search-bar-events'
import {useCallback} from 'react'
import {useLocation} from 'react-router-dom'
import {useSoftNavigate} from './use-soft-navigate'
import {getCanonicalSearchMetadata, type SearchParams} from '../../../../../app/components/search/parsing/parsing'

export function shouldOpenInNewTab(event: React.MouseEvent | React.KeyboardEvent) {
  // eslint-disable-next-line @github-ui/ui-commands/no-manual-shortcut-logic
  return event.ctrlKey || event.metaKey || (event as React.MouseEvent).button === 1
}

/**
 * Returns a function that will update the search results and the search header with the new query.
 */
export function useNavigateToQuery(): (
  query?: string,
  filter?: string,
  searchParams?: SearchParams,
  openInNewTab?: boolean,
  logged_in?: boolean,
) => void {
  const navigateToSearch = useSoftNavigate(searchPath)
  return useCallback(
    async (
      query?: string,
      filter?: string,
      searchParams?: SearchParams,
      openInNewTab?: boolean,
      logged_in?: boolean,
    ) => {
      const metadata = getCanonicalSearchMetadata({
        rawQuery: query || '',
        params: searchParams || {},
        filter,
        logged_in,
      })

      updateSearchBar(metadata.query)
      const payload = {...metadata.params, q: metadata.query}

      if (openInNewTab) {
        window.open(getUrl(searchPath, undefined, payload).href, '_blank')
      } else {
        navigateToSearch(undefined, payload)
      }
    },
    [navigateToSearch],
  )
}

export function useQueryUrl(): (
  query?: string,
  filter?: string,
  searchParams?: SearchParams,
  logged_in?: boolean,
) => string {
  const location = useLocation()

  return useCallback(
    (query?: string, filter?: string, searchParams?: SearchParams, logged_in?: boolean) => {
      const metadata = getCanonicalSearchMetadata({
        rawQuery: query || new URLSearchParams(location.search).get('q') || '',
        params: searchParams || {},
        filter,
        logged_in,
      })

      return getUrl(searchPath, undefined, {...metadata.params, q: metadata.query}).href
    },
    [location],
  )
}
